import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PrintRoundedIcon from "@material-ui/icons/PrintRounded";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import { Button } from "@material-ui/core";
import exporter from "../../../../../../utils/exporter";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingRight: theme.spacing(1),
    textAlign: "right",
    display: "contents",
  },
  Icons: {
    color: "#828282",
  },
}));

export default function ActionBar(props) {
  const classes = useStyles();
  const { list, summarytier } = props.dataExportExcel;
  const [mappingList, setMappingList] = React.useState();
  React.useEffect(() => {
    const mapping = [...list, summarytier[0]].map((data) => {
      const entry = Object.entries(data);
      const newEntry = [].concat(
        ...entry.map((item) => {
          if (item[0].includes(" and ")) {
            const [newKey1, newKey2] = item[0].split(" and ");
            const [newVal1, newVal2] = item[1].split("<br>");
            return [
              [newKey1, newVal1 || ""],
              [newKey2, newVal2 || ""],
            ];
          }
          return [item];
        })
      );
      return Object.fromEntries(newEntry);
    });
    setMappingList(mapping);
  }, [list, summarytier, props.list]);

  return (
    <div className={classes.root}>
      <Button
        onClick={() => {
          exporter(mappingList, undefined, props.pageName);
        }}
        style={{ padding: "2px 8px" }}
      >
        <SaveAltIcon fontSize="large" className={classes.Icons} />
      </Button>
      <Button onClick={props.handlePrint} style={{ padding: "2px 8px" }}>
        <PrintRoundedIcon fontSize="large" className={classes.Icons} />
      </Button>
    </div>
  );
}
